export const DEFAULT_TOTAL_DAILY_CAPACITY = 8;

export const generateDailyTimeSlots = (slotCount) => {
  const count = Number.parseInt(slotCount, 10);
  if (!Number.isInteger(count) || count < 1 || count > 16) return [];

  const startMinutes = 8 * 60;
  const intervalMinutes = Math.floor((16 * 60 - startMinutes) / count);
  return Array.from({ length: count }, (_, index) => {
    const minutes = startMinutes + index * intervalMinutes;
    return `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`;
  });
};

export const DEFAULT_RESERVATION_POOLS = [
  {
    id: "oschatz-transfer",
    name: "Destynacje przeniesione z Oschatz",
    codes: ["XWR3", "LCJ2", "KTW5", "WRO1", "XPO1", "XPLC"],
    maxPerDay: 4,
    capacityRanges: [],
    looseSlotsPerMonth: 1,
  },
  {
    id: "hoyerswerda-existing",
    name: "Destynacje Hoyerswerdy",
    codes: ["WRO5", "PRG2", "WRO2", "POZ1", "POZ2", "SZZ1"],
    maxPerDay: 4,
    capacityRanges: [],
    looseSlotsPerMonth: 1,
  },
];

export const getReservationPoolIds = (cars, pools) => {
  const receivingCodes = new Set(
    (cars || [])
      .map((car) => String(car?.receiving || "").trim().toUpperCase())
      .filter(Boolean)
  );

  return (pools || [])
    .filter((pool) =>
      (pool.codes || []).some((code) => receivingCodes.has(String(code).trim().toUpperCase()))
    )
    .map((pool) => pool.id);
};

export const reservationMatchesPool = (reservation, pool) => {
  if ((reservation.poolIds || []).includes(pool.id)) return true;

  const receivingCodes = new Set(
    (reservation.cars || [])
      .map((car) => String(car?.receiving || "").trim().toUpperCase())
      .filter(Boolean)
  );

  return (pool.codes || []).some((code) => receivingCodes.has(String(code).trim().toUpperCase()));
};

export const receivingOptionsForPools = (pools) =>
  (pools || []).flatMap((pool, poolIndex) =>
    (pool.codes || []).map((code, codeIndex) => ({
      id: `${pool.id}-${codeIndex}`,
      label: code,
      value: code,
      name: code,
      poolId: pool.id,
      poolIndex,
    }))
  );

export const getPoolDailyLimit = (pool, date, fallback = 4) => {
  const dateKey = typeof date === "string"
    ? date.slice(0, 10)
    : `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  const range = (pool.capacityRanges || []).find((entry) =>
    entry.startDate <= dateKey && entry.endDate >= dateKey
  );
  return Number(range ? range.maxPerDay : pool.maxPerDay ?? fallback);
};